// extracted by mini-css-extract-plugin
export default {"cls1":"PostComments-cls1_LCQ","cls2":"PostComments-cls2_agd PostComments-cls1_LCQ","show":"PostComments-show__X_"};